module.exports = __webpack_public_path__ + "img/gift.e0280b50.png";